<template>
    <div>
        绩效监控
        <!-- <el-empty description="正在开发中~"></el-empty> -->
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style scoped>
</style>
